// extracted by mini-css-extract-plugin
module.exports = {"mark-order":"MarkOrder_mark-order__SrCoN","markOrderBgIcon":"MarkOrder_markOrderBgIcon__Gt_ix"};